import React, { useState, useEffect } from 'react';

const NewStoreAnTemplateWidget = ({ selectedLayout,isTemplateId,widgetId,announcementBarTabData }) => {
    const [isClosePopupWidget, setIsClosePopupWidget] = useState(true);
        
    const {
        is_website_frontend,
        message,
        action_element_type,
        action_element_button_text,
        action_element_button_link,
        visual_element_type,
        visual_element_badge_text,
        postion_type,
        bar_size_type,
        is_close_button,
        background_color,
        message_color,
        badge_color,
        button_color,
        bar_link,
    } = announcementBarTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/announcement-bar/temp-css/AnnouncementBarWidget.css`;
        if (widgetId) {
            link.setAttribute("announcement-bar-data-dynamic-css", "announcement-bar");
        } else {
            link.setAttribute("data-dynamic-css", "announcement-bar");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="announcement-bar"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    // Function to toggle the popup and show it again after 3seconds if hidden
    const toggleClosePopupWidget = () => {
        setIsClosePopupWidget(false); 

        // Show popup again after 3 seconds
        setTimeout(() => {
            setIsClosePopupWidget(true);
        }, 3000);
    };

    //Set Sizes
    const fontSizeMap = {Large: '18px',Medium: '14px',Small: '12px'};
    // Fallback to medium if undefined
    const dynamicFontSize = fontSizeMap[bar_size_type] || '14px';

    return (
        <>
            <div className={`upgadeify announcement_bar announcement-bar-new-store-announcement-temp ${is_website_frontend}`}>
                {isClosePopupWidget && (
                    <div className={`announcement_sale_main ${postion_type} ${bar_size_type}`} style={{background: background_color}}>
                        <div className='announcement_sale_main_inner'>
                            {visual_element_type=== "Badge" && (
                                <button className='announcement_btnrounded' style={{ fontSize: dynamicFontSize, color: button_color }}>
                                {visual_element_badge_text}
                                </button>
                            )}
                            <h3 style={{ color: message_color, fontSize: dynamicFontSize }}>
                                <a href={bar_link} target="_blank" rel="noopener noreferrer" style={{ color: message_color, textDecoration: 'none' }}>
                                {message}
                                </a>
                            </h3>

                            {action_element_type === "Button" && (
                                <a className='announcement_btnshop' style={{fontSize: dynamicFontSize, color: badge_color, fontWeight: "700",}} 
                             href={action_element_button_link} target="_blank" rel="noopener noreferrer">
                                    {action_element_button_text}
                                </a>
                            )}

                            {Number(is_close_button) === 1 && (
                                <button className="announcement-close-button" onClick={toggleClosePopupWidget} aria-label="Close" style={{ color: "#000" }}>
                                &times;
                                </button>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default NewStoreAnTemplateWidget;
